import { IBase } from "../base.interface";

export interface IKitchenArea extends IBase {
  name: string;
}